import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../../components-v2/Theme/theme';
import { warningDark, warningLight } from '../../../../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	// Checkbox styles
	checkboxContainer: {
		width: 12,
		height: 12,
		border: `2px solid ${THEME.colors.primary.main}`,
		borderRadius: 3,
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		transition: 'all 0.2s ease',
		flexShrink: 0,
		backgroundColor: THEME.colors.background.light,
		':hover': {
			backgroundColor: THEME.colors.primary.light,
		},
	},
	checkboxCompleted: {
		backgroundColor: THEME.colors.success.main,
		borderColor: THEME.colors.success.main,
	},
	checkboxOverdue: {
		backgroundColor: THEME.colors.background.light,
		borderColor: warningDark,
		':hover': {
			backgroundColor: warningLight,
		},
	},
	checkboxDisabled: {
		opacity: 0.5,
		cursor: 'not-allowed !important',
	},
	checkmark: {
		color: THEME.colors.background.light,
		fontSize: 12,
		fontWeight: 'bold',
	},
	checkmarkOverdue: {
		color: THEME.colors.warning.light,
	},

	// Action item content styles
	actionItemContainer: {
		padding: 12,
		borderRadius: THEME.common.borderRadius,
	},

	actionItemMainRow: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: THEME.spacing.sm,
		marginBottom: THEME.spacing.xs,
	},

	actionItemContent: {
		flex: 1,
		minWidth: 0,
	},

	actionItemTitle: {
		fontSize: 14,
		fontWeight: 500,
		color: THEME.colors.text.main,
		marginBottom: THEME.spacing.xs,
		wordBreak: 'break-word',
	},

	creatorInfo: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.xs,
		marginBottom: THEME.spacing.xs,
	},

	avatar: {
		width: 24,
		height: 24,
		borderRadius: '50%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		fontSize: 10,
		fontWeight: 600,
	},

	creatorName: {
		fontSize: 13,
		color: THEME.colors.primary.main,
		textDecoration: 'none',
		cursor: 'pointer',
		':hover': {
			textDecoration: 'underline',
		},
	},

	assignedInfo: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.xs,
		fontSize: 12,
		color: THEME.colors.text.dark,
	},

	actionButton: {
		flexShrink: 0,
	},

	actionItemSubtitle: {
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	actionItemSubtitleLabel: {
		fontSize: 12,
	},
	actionItemSubtitleDueDate: {
		fontSize: 12,
		color: THEME.colors.text.main,
	},
	actionItemSubtitleButton: {
		fontSize: 12,
		height: 'fit-content',
		color: THEME.colors.primary.main,
	},
	actionItemSubtitleAssignedTo: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.xs,
	},
	actionItemAction: {
		paddingTop: THEME.spacing.xs,
		paddingBottom: THEME.spacing.xs,
	},
	actionItemActionIcon: {
		display: 'block',
		'@container timelineCard (min-width: 300px)': {
			display: 'block',
		},
		'@container timelineCard (min-width: 600px)': {
			display: 'none !important',
		},
		'@container timelineCard (min-width: 700px)': {
			display: 'block !important',
		},
	},
	actionItemActionText: {
		display: 'none',
		'@container timelineCard (min-width: 300px)': {
			display: 'none',
		},
		'@container timelineCard (min-width: 600px)': {
			display: 'block',
		},
	},
});
